import { styled } from '@mui/material/styles';
import { Input } from 'components/ui';

export const FirmDocumentFolderCreateDialogField = styled('div')(({ theme }) => ({
  display: 'grid',
  gap: theme.spacing(1),
  minWidth: theme.spacing(48),
}));

export const FirmDocumentFolderCreateDialogFieldGroup = styled('div')(({ theme }) => ({
  display: 'grid',
  gap: theme.spacing(2),
}));

export const FirmDocumentFolderCreateDialogLabel = styled('label')(({ theme }) => ({
  color: theme.palette.neutral[600],
  fontSize: 'var(--dialog-description-font-size)',
  fontWeight: theme.typography.fontWeightMedium,
  lineHeight: 'var(--dialog-description-line-height)',
}));

export const FirmDocumentFolderCreateDialogInput = styled(Input)(({ theme }) => ({
  '&& .MuiOutlinedInput-root': {
    backgroundColor: theme.palette.background.paper,
    borderRadius: 'var(--dialog-select-trigger-radius)',
    color: theme.palette.neutral[900],
    fontSize: 'var(--dialog-description-font-size)',
    lineHeight: 'var(--dialog-description-line-height)',
    minHeight: 'var(--dialog-select-trigger-height)',
    padding: 0,
    transition: theme.transitions.create(['background-color', 'border-color', 'box-shadow'], {
      duration: theme.transitions.duration.shortest,
    }),
  },
  '&& .MuiOutlinedInput-input': {
    boxSizing: 'border-box',
    fontSize: 'var(--dialog-description-font-size)',
    lineHeight: 'var(--dialog-description-line-height)',
    padding: theme.spacing(2),
    '&::placeholder': {
      color: theme.palette.neutral[500],
      opacity: 1,
    },
  },
  '&& .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.neutral[300],
    borderWidth: 'var(--dialog-border-width)',
    transition: theme.transitions.create('border-color', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  '&& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.neutral[400],
  },
  '&& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.brand[400],
    borderWidth: 'var(--dialog-border-width)',
  },
  '&& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline, && .MuiOutlinedInput-root.Mui-error:hover .MuiOutlinedInput-notchedOutline, && .MuiOutlinedInput-root.Mui-error.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.red[500],
    borderWidth: 'var(--dialog-border-width)',
  },
  '&& .MuiOutlinedInput-root.Mui-disabled': {
    backgroundColor: theme.palette.action.disabledBackground,
    color: theme.palette.action.disabled,
  },
  '&& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.neutral[200],
  },
  '&& .MuiFormHelperText-root': {
    color: theme.palette.neutral[500],
    fontSize: 'var(--dialog-description-font-size)',
    lineHeight: 'var(--dialog-description-line-height)',
    marginLeft: 0,
    minHeight: 'var(--dialog-description-line-height)',
  },
  '&& .MuiFormHelperText-root.Mui-error': {
    color: theme.palette.red[600],
  },
}));
